export default [
  {
    path: '/items',
    component: () => import('./views/Index'),
    name: 'items',
    redirect: { name: 'items-list' },
    children: [
      {
        path: '/items',
        name: 'items-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'auth',
        },
      },
      {
        path: '/items/detail/:item_id',
        name: 'item-detail',
        component: () => import('./views/Detail'),
        meta: {
          resource: 'auth',
        },
      },
    ],
  },
]
